import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const getCms = createAsyncThunk(
  "getCms/getCmsUsers",
  async (payload, thunkAPI) => {
    try {
      
      const response = await api.post("cms", payload);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const getCmsSlice = createSlice({
  name: "getCms",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCms.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCms.fulfilled, (state, action) => {
          

        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getCms.rejected, (state, action) => {
       
        state.loading = false;
        state.error = action.payload;
        state.data = []
      });
  },
});

export default getCmsSlice.reducer;
